<template>
  <div class="task-contents">
    <ul>
      <li class="insert">
        <Img src="/icon-invite.png" />
      </li>
      <li class="name">
        <span v-if="formData.state === 0">Hi {{ queryData.inviter }}</span
        ><span v-if="formData.state === 0">邀请你</span>加入项目
        {{ queryData.p_name }}
      </li>
      <li v-if="formData.state === 0">
        <Button type="primary" :loading="loading" @click="join()">加入项目</Button>
      </li>
      <li class="state" v-if="formData.state === 1">
        <Img src="/icon-chenggong.png" />
        <p class="name">加入成功</p>
        <p class="des">你已经加入项目 {{ queryData.p_name }} <span class="link" @click="goProject()">快去看看吧</span></p>
      </li>
      <li class="state" v-if="formData.state === 2">
        <Img src="/icon-shibai.png" />
        <p class="name">加入项目失败</p>
        <p class="des">{{ formData.error }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
import { Button } from 'view-design'
import Img from '../../components/Img.vue'
export default {
  components: { Img, Button },
  data() {
    return {
      loading: false,
      formData: {
        error: '',
        state: 0
      },
      queryData: {
        inviter: undefined,
        p_name: '',
        p_id: undefined,
        herf: '',
        invite: ''
      },
      invite_url: ''
    }
  },
  created() {
    this.queryData = { ...this.$route.query }
    this.queryData.herf = window.location.href
    sessionStorage.setItem('invite', JSON.stringify(this.queryData))
    sessionStorage.setItem('invite_url', window.location.href)
  },
  methods: {
    async join() {
      const params = {
        uriCode: 'API028',
        herf: this.queryData.herf,
        invite: this.queryData.invite
      }
      try {
        this.loading = true
        const res = await this.$fetch(params)
        if (res) {
          this.formData.error = res
          this.formData.state = 2
        } else {
          this.formData.state = 1
        }
        console.log(res, 'res')
      } finally {
        this.loading = false
      }
    },
    goProject() {
      const islogin = localStorage.getItem('userinfo')
      if (islogin) {
        this.$router.push({ name: 'combat_camp_detail', query: { id: this.queryData.p_id } })
      } else {
        this.$router.push({ name: 'login' })
      }
    }
  }
}
</script>
<style lang="scss">
.task-contents {
  background-color: #fff;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  justify-content: center;
  min-height: 668px;
  ul {
    max-width: 1440px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    .insert {
      img {
        width: 500px;
        height: 254px;
        margin-bottom: 100px;
      }
    }
    .name {
      font-size: 28px;
      font-weight: 500;
      color: #1c2a34;
      line-height: 48px;
    }
    .state {
      img {
        width: 80px;
        height: 80px;
        margin: 60px 0 30px 0;
      }
      .des {
        font-size: 14px;
        font-weight: 400;
        color: rgba(28, 42, 52, 0.45);
        line-height: 22px;
        margin-top: 16px;
      }
      .link {
        cursor: pointer;
        color: #468fef;
      }
      .link:hover {
        color: #468fef;
      }
    }
  }
  .ivu-btn {
    width: 250px !important;
    height: 40px !important;
    text-align: center;
    line-height: 40px !important;
    padding: 0 70px !important;
    border-radius: 23px !important;
    margin-top: 60px;
  }
}
</style>
